'use client'

import { useCallback, useMemo } from 'react'

import ExpandablePanel from 'shared/ui/ExpandablePanel'
import { RadioItem } from 'shared/ui/RadioGroup'
import { formatToSimpleDate } from 'shared/utils/date'

import { FiltersRadioGroup } from './styles'
import { getDaysToFilterBy } from './WeeklyAvailabilityFilter'

import styles from './WeeklyAvailabilityFilterMobile.module.scss'

interface WeeklyAvailabilityFilterMobileProps {
  value: string | null
  onChange: (path: string, value: string | null) => void
  deliveryDates: string[]
}

const WeeklyAvailabilityFilterMobile = ({
  onChange,
  value,
  deliveryDates
}: WeeklyAvailabilityFilterMobileProps) => {
  const daysToFilterBy = getDaysToFilterBy(deliveryDates)

  const selectedValue = useMemo(() => value ?? 'all', [value])

  const handleSelect = useCallback(
    (filterValue: string | null) => {
      onChange(
        'daily_availability_plan',
        filterValue === 'all' ? null : filterValue
      )
    },
    [onChange]
  )

  return (
    <ExpandablePanel
      title={'Dostępność w dostawie'}
      id='weekly-availability-filter-mobile'
    >
      <FiltersRadioGroup
        name='mobile-weekly-availability'
        selectedValue={selectedValue}
        onChange={handleSelect}
      >
        <RadioItem value='all'>Dowolny dzień</RadioItem>
        {daysToFilterBy.map(day => {
          const { date, dayOfWeek } = day

          return (
            <RadioItem key={`mobile-${dayOfWeek}-${date}`} value={date}>
              <div className={styles.filterLabel}>
                <div>{dayOfWeek}</div>
                <div>{formatToSimpleDate(date)}</div>
              </div>
            </RadioItem>
          )
        })}
      </FiltersRadioGroup>
    </ExpandablePanel>
  )
}

export default WeeklyAvailabilityFilterMobile
